import { render, staticRenderFns } from "./VerificationNumberFormDialog.vue?vue&type=template&id=55989c12&"
import script from "./VerificationNumberFormDialog.vue?vue&type=script&lang=js&"
export * from "./VerificationNumberFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports